export default __webpack_public_path__ + "static/media/myBetsCardWonBG.ed62c723.png";